module.exports = __webpack_public_path__ + "img/connected-world.5bca1dc6.webp";